import OmronFooter from "components/OmronFooter";
import OmronHeader from "components/OmronHeader";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

const VerifyUserCompletePage: React.FC = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <MainWrapper>
      <OmronHeader
        link={{ path: "/", label: t("common.label.breadcrumbsSignin") }}
        label={[
          t("common.label.breadcrumbsSignup"),
          t("common.label.breadcrumbsSignupConf"),
          t("common.label.breadcrumbsVerifyUserComplete"),
        ]}
      />
      <PageMain>
        <InnerDiv>
          <Title>{t("verifyUser.label.completeTitle")}</Title>
          <Text>{t("verifyUser.text.complete")}</Text>
          <Text>
            <Button href="/">{t("verifyUser.label.loginPageButton")}</Button>
          </Text>
        </InnerDiv>
      </PageMain>
      <OmronFooter />
    </MainWrapper>
  );
};

export default VerifyUserCompletePage;

const MainWrapper = styled.div`
  display: grid;
  grid-template-rows: 76px 40px 1fr auto;
  grid-template-areas:
    "header"
    "breadc"
    "main"
    "footer";
  min-height: 100vh;
`;
const PageMain = styled.main`
  grid-area: main;
  padding: 3.2rem 50px;
`;

const InnerDiv = styled.div`
  width: 1000px;
  margin: 0 auto;
`;
const Text = styled.p`
  white-space: pre-wrap;
  margin-bottom: 3rem;
  font-size: 14px;
  line-height: 1.7;
  letter-spacing: 0;
  font-weight: normal;
  text-align: center;
`;
const Button = styled.a`
  display: inline-block;
  width: 15rem;
  padding: 1.23rem 2rem;
  color: #ffffff;
  background: #005eb8;
  border: 1px #005eb8 solid;
  text-decoration: none;
  font-size: 14px;
  line-height: 1.4;
  letter-spacing: 0;
  font-weight: normal;
  transition: all 0.3s ease-out;
  :hover {
    background: rgba(0, 94, 184, 0.7);
  }
`;
const Title = styled.h1`
  margin-bottom: 3rem;
  text-align: center;
`;
